import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { signOut, signOutAllDevices } from './authSlice';

export interface SearchLocation {
  coords: { lat: number; lng: number };
  /** What the customer sees for it: a saved address's name ("Home", "Office") or a place name. */
  label: string | null;
}

interface SearchLocationState {
  current: SearchLocation | null;
}

const initialState: SearchLocationState = { current: null };

/**
 * Where the customer is looking for shops. Home owns picking it (a saved address, or the phone's
 * position); Discover, the map, search and profiles read it, so every "nearby", "recommended"
 * and distance on screen is measured from the same place.
 */
const searchLocationSlice = createSlice({
  name: 'searchLocation',
  initialState,
  reducers: {
    setSearchLocation(state, action: PayloadAction<SearchLocation | null>) {
      state.current = action.payload;
    },
  },
  extraReducers: (builder) => {
    // The picked address belongs to the account that picked it.
    builder.addCase(signOut.fulfilled, () => initialState).addCase(signOutAllDevices.fulfilled, () => initialState);
  },
});

export const { setSearchLocation } = searchLocationSlice.actions;
export default searchLocationSlice.reducer;
